<template slot-scope="scope">
  <!-- 处理结果弹窗 -->
      <dialogModel
        :title="PopUpTitle"
        :visible="dialogVisible"
        @handleClose="handleClose"
        @handleOk="handleUnderstand"
      >
        <div class="main-body" v-if="result == '0' || result == '1'">
            <div class="left-title">
              <p v-if="result == '0'">当前手机号：</p>
              <p v-if="result == '1'">当前邮箱：</p>

              <p v-if="result == '0'">
                <span style="color: red">*</span>新手机号：
              </p>
              <p v-if="result == '1'">
                <span style="color: red">*</span>新邮箱：
              </p>
              <p><span style="color: red">*</span>验证码：</p>
            </div>

            <div class="right-content">
              <div v-if="result == '0'" class="Current">
                {{ this.$store.getters.getUser.phone }}
              </div>
              <div v-if="result == '1'" class="Current">
                {{ this.$store.getters.getUser.mail }}
              </div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <!-- 手机号 -->
                <el-form-item prop="input" v-if="result == '0'">
                  <div class="input-box">
                    <el-input
                      v-model="ruleForm.input"
                      placeholder="请输入"
                    ></el-input>
                  </div>
                </el-form-item>
                <!-- 邮箱 -->
                <el-form-item prop="mail" v-if="result == '1'">
                  <div class="input-box">
                    <el-input
                      v-model="ruleForm.mail"
                      placeholder="请输入"
                    ></el-input>
                  </div>
                </el-form-item>
                <el-form-item prop="Code">
                  <div class="input-box">
                    <el-input
                      v-model="ruleForm.Code"
                      placeholder="请输入"
                    ></el-input>
                    <p
                      class="verify"
                      @click="second == 60 ? handelInvoke('ruleForm') : ''"
                    >
                      {{
                        second === totalSecond && sendNum == 0
                          ? "获取验证码"
                          : second === totalSecond && sendNum != 0
                          ? "再次获取验证码"
                          : second + `s`
                      }}
                    </p>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- 添加屏蔽公司 -->
          <div class="main-body" v-if="result == '2'">
            <div class="shield">
              <p><span style="color: red">*</span>企业名称：</p>
              <div>
                <el-form
                  :model="ruleForm"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="100px"
                  class="demo-ruleForm"
                >
                  <el-form-item prop="input1">
                    <el-select
                      v-model="ruleForm.input1"
                      filterable
                      remote
                      placeholder="请输入关键词"
                      :remote-method="remoteMethod"
                      :loading="loading"
                      @change="pestChange"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.id"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>

          <!-- 删除 -->
          <div class="main-body" v-if="result == '3'">
            <div class="unmask">
              <p>确认删除对该公司的屏蔽?</p>
            </div>
          </div>
      </dialogModel>
</template>

<script>
// 引入接口
import {
  postUpdateUserPhoneOrMail, // 更换绑定 手机号/邮箱
  postSendAuthCode, // 获取邮箱/手机验证码
  postGetCompanyListByName, // 根据公司名搜索公司
  postAddShieldCompany, // 增加屏蔽公司接口
} from "../../../../../../assets/api/index";
import { mapActions } from "vuex";
// 封装的表单验证
import { vxRule } from "../../../../../../../untils/FormValidation/validate-form";

// 在弹窗中获取验证码 destroyed中的应写在handleClose/handleUnderstand中才生效
export default {
  props: {
    dialogVisible: {},
    result: {},
    PopUpTitle: {},
  },
  components: {},
  data() {
    return {
      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      sendNum: "0", // 发送次数首次叫获取验证码之后叫再次发送验证码
      ruleForm: {
        Code: "", // 验证码
        input: "", // 新手机号
        input1: "", // 添加屏蔽公司
        mail: "", // 邮箱
      },
      rules: {
        // 参数3 change触发，为空时使用自定义提示语    blur
        // 参数4 自定义提示语 / 没有时用封装的
        // 参数2 封装的规则名 / 自定义规则
        // 参数1 false时不验证为空
        Code: vxRule(true, "", ["blur", "change"], "请输入验证码"),
        input1: vxRule(true, "", ["blur", "change"], "请选择要屏蔽的企业"),

        input: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: ["blur", "change"],
            pattern: /^\s*1[3-9]\d{9}\s*$/,
          },
        ],
        mail: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的邮箱",
            trigger: ["blur", "change"],
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          },
        ],
        // mail: vxRule(true, "Email", ["blur", "change"]),
      }, // 表单验证

      // 添加屏蔽公司检索公司名要用到的
      options: [],
      value: [],
      list: [],
      loading: false, // 添加屏蔽公司加载状态
      states: [], // 添加屏蔽公司 公司数据列表
      shieldObj: {}, // 添加屏蔽公司 接口所需数据
    };
  },
  watch: {
    // 监听
    dialogVisible: {
      // 表格改变清空多选内容
      handler(newss, old) {
        if (newss == false) {
          this.ruleForm = {
            Code: "", // 验证码
            input: "", // 新手机号
            input1: "", // 添加屏蔽公司
            mail: "", // 邮箱
          };
          // 关闭验证码倒计时 数据归位
          clearInterval(this.timer);
          this.timer = null; // 重置定时器 id
          this.second = this.totalSecond; // 归位
          this.sendNum = "0";
          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 300);
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  destroyed() {
    clearInterval(this.timer);
    this.timer = null; // 重置定时器 id
    this.second = this.totalSecond; // 归位
  },
  mounted() {},
  methods: {
    ...mapActions(["SET_PHONE", "SET_MAIL"]),
    // 选择 企业名称完毕 获取需要的值
    pestChange(val) {
      var data = {};
      data.data = {
        name: val,
      };
      postGetCompanyListByName(data, 1, 10).then((res) => {
        // 给添加屏蔽公司接口所需的数据赋值
        this.shieldObj = {
          userId: this.$store.getters.getUser.id,
          companyId: res.data.list[0].id,
          companyName: res.data.list[0].name,
        };
        console.log(this.shieldObj);
      });
    },
    // 远程搜索
    async remoteMethod(query) {
      // 远程搜索前调用接口，传入搜索的数据获取企业名称放入this.states
      var data = {};
      data.data = {
        name: query,
      };
      if (query !== "") {
        // 调用 获取企业名称接口
        await postGetCompanyListByName(data, 1, 10).then((res) => {
          this.states = res.data.list;
          this.list = this.states.map((item) => {
            return {
              value: `${item.name}`,
              label: `${item.name}`,
              id: `${item.id}`,
            };
          });
        });
        // 组件 自带远程搜索的函数

        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },

    // ---------------------------- 点击发送验证码 接口 -----------------------
    handelInvoke(formName) {
      if (this.result == "1") {
        this.$refs[formName].validateField("mail", (errMsg) => {
          if (errMsg) {
            console.log("校验未通过");
          } else {
            this.postSendAuthCode();
          }
        });
      } else {
        this.$refs[formName].validateField("input", (errMsg) => {
          if (errMsg) {
            console.log("校验未通过");
          } else {
            this.postSendAuthCode();
          }
        });
      }
    },
    postSendAuthCode() {
      // 获取验证码接口
      var data = {};
      data.data = {
        mail: this.ruleForm.mail,
        mobile: this.ruleForm.input,
        type: this.result,
        authCodeBusiness: "3",
      };
      postSendAuthCode(data).then((res) => {
        if (res.code == 0) {
          this.Countdown();
          this.$tool.PromptBox("success", "验证码已发送");
        } else {
          // 验证码发送失败
          // this.$tool.PromptBox("error", "验证码发送失败");
        }
      });
    },
    // -------------------------------- 发送验证码倒计时----------------------
    Countdown() {
      this.textCode = false;
      var that = this;
      setTimeout(function () {
        that.sendNum++;
        console.log(that.sendNum);
        // 时间间隔
      }, 1000);

      // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
      if (!this.timer && this.second === this.totalSecond) {
        console.log("111");
        // 开启倒计时
        this.timer = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            clearInterval(this.timer);
            this.timer = null; // 重置定时器 id
            this.second = this.totalSecond; // 归位
          }
        }, 1000);
      }
    },
    // 取消/关闭弹窗
    handleClose() {
      this.$emit("handleClose", this.result);
    },
    // 修改手机号/邮箱接口
    postUpdateUserPhoneOrMail() {
      var data = {};
      // 参数 赋值
      data.data = {
        newMail: this.ruleForm.mail, // 新邮箱
        newMobile: this.ruleForm.input, // 新手机号
        mail: this.$store.getters.getUser.mail, // 老邮箱
        mobile: this.$store.getters.getUser.phone, // 老手机号
        type: this.result,
        authCode: this.ruleForm.Code,
      };
      // 调用 修改手机号/邮箱 接口
      postUpdateUserPhoneOrMail(data).then((res) => {
        // 修改成功
        if (res.code == 0) {
          // 修改 vuex中的手机号/邮箱
          if (this.result == "0") {
            this.$store.commit("SET_PHONE", this.ruleForm.input);
          } else if (this.result == "1") {
            this.$store.commit("SET_MAIL", this.ruleForm.mail);
          }

          // 关闭弹窗
          this.$tool.PromptBox("success", "操作成功");
          this.$emit("handleUnderstand");
        } else {
          // 修改失败
          // this.$tool.PromptBox("error", res.msg);
        }
      });
    },
    // 确认
    handleUnderstand() {
      // 更换邮箱 / 手机号   添加屏蔽公司
      if (this.result == "0" || this.result == "1" || this.result == "2") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            // 处理 更换手机号 / 邮箱
            if (this.result == "0") {
              this.postUpdateUserPhoneOrMail();
            } else if (this.result == "1") {
              // 处理 更换手机号 / 邮箱
              // 使用标准邮箱格式正则表达式校验
              const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
              if (emailRegex.test(this.ruleForm.mail)) {
                // 判断新邮箱是否和旧邮箱一致
                if (this.ruleForm.mail != this.$store.getters.getUser.mail) {
                  this.postUpdateUserPhoneOrMail();
                } else {
                  this.$tool.PromptBox("error", "新邮箱与旧邮箱一致");
                }
              } else {
                this.$tool.PromptBox("error", "新邮箱格式验证失败");
              }
            } else if (this.result == "2") {
              var data = {};
              data.data = this.shieldObj;
              // 处理添加屏蔽公司
              postAddShieldCompany(data).then((res) => {
                if (res.code == 0) {
                  // 修改 vuex中的手机号/邮箱
                  this.$tool.PromptBox("success", "操作成功");
                  // 添加屏蔽企业成功 关闭弹窗时 传值给父组件 让父组件在关闭弹窗时刷新一下屏蔽企业列表数据展示最新的列表数据
                  this.$emit("handleUnderstand", this.result);
                } else {
                  // 修改失败
                  // this.$tool.PromptBox("error", res.msg);
                }
              });
            }
          } else {
            return false;
          }
        });
      } else {
        // 删除 屏蔽公司
        this.$emit("handleUnderstand", this.result, this.ruleForm);
      }
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item {
  margin-bottom: 0px;
}
/deep/.el-form-item__error {
  position: absolute;
  padding-top: 2px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
/deep/.el-input__inner {
  //   width: 250px;
  height: 35px !important;
  border: 1px solid #409eff ;
}

.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}

.main-body {
  width: 600px;
  min-height: 100px;
  margin: 0 auto;
  display: flex;
  .shield {
    width: 450px;
    height: 35px;
    margin: auto 0;
    display: flex;
    line-height: 35px;
    p {
      min-width: 80px;
      font-size: 14px;
      color: #333333;
      font-weight: 400;
    }
    div {
      flex: 1;
    }
  }
  .left-title {
    min-width: 110px;
    flex-shrink: 0;
    text-align: right;
    p {
      height: 35px;
      line-height: 35px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #333333;
      text-align: right;
      font-weight: 400;
      margin-bottom: 30px;
      white-space: nowrap;
    }
  }

  .right-content {
    flex: 1;
    .Current {
      height: 35px;
      line-height: 35px;
    }
    .input-box {
      width: 350px;
      height: 35px;
      line-height: 35px;
      margin-top: 30px;
      display: flex;
      position: relative;
      .verify {
        position: absolute;
        right: 15px;
        color: #409eff ;
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}
</style>
